import React from 'react'
import DeclineContent from './DeclineContent'

export default function DeclinePage () {
  return (
    <div className='declinePage web'>
      <DeclineContent />
    </div>
  )
}
